import axios from "axios";
import { BASE_URL } from "@funded-here-interface/common/src/constant/constant";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface OverwriteNameRequest {
  token: string;
}

const overwriteName = async ({
  token,
}: OverwriteNameRequest): Promise<string> => {
  try {
    const response = await axios.post(
      `${BASE_URL}/trade-directory/users/overwrite-name`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default overwriteName;
